import React from "react";
import { withSafeRotateSvg } from "../../hoc/withSafeRotateSvg";

const FuzzyBorderVertical: React.FC<DogsTrust.CurveProps> = ({
	fill = "#FFC800",
	className,
	style,
}) => {
	return (
		<svg
			className={className}
			style={style}
			aria-hidden="true"
			focusable="false"
			viewBox="0 0 360 1920"
			xmlns="http://www.w3.org/2000/svg"
			preserveAspectRatio="xMidYMid slice"
		>
			<path
				d="M.003 1920.003V.003h303.403c-4.933.008-7.401.02-7.404.036l-.295 1.799-.187 1.138c-3.16 19.273-21.056 128.68-29.728 187.374-6.032 39.571-10.91 73.471-14.55 101.396-10.258-6.98-18.833-15.82-26.823-26.865-12.631-17.475-34.305-54.612-40.014-71.004a7864.73 7864.73 0 00-9.66 45.656c-18.496 94.951-31.246 185.37-38.33 274.582-21.243 267.627 5.756 722.317 27.746 845.814-33.927-13.708-65.32-39.085-99.723-84.577 17.986 144.2 103.753 428.161 131.014 465.15-47.167-7.173-75.593-24.201-81.762-28.206-.43-.281-.91.24-.726.775 4.859 14.43 41.307 121.631 80.056 206.912.004.008 5.016.014 15.036.018l2.071.001h1.086H.003zm360 0h-18.844 2.562l6.412-.002L360 1920V.002h.003v1920z"
				fill={fill}
				fillRule="evenodd"
			/>
		</svg>
	);
};

export default withSafeRotateSvg<DogsTrust.CurveProps>(FuzzyBorderVertical);
